import { HttpStatus } from '../errors';
import type { ErrorResponse } from '../errors';

export enum Errors {
  INVALID_POSTAL_CODE = HttpStatus.BAD_REQUEST,
}

export type StateErrorResponse = ErrorResponse<Record<string, string>>;
